// // import React, { useEffect, useState } from "react";
// // import axios from "axios";
// // import { useLoader } from "../../../../context/LoaderProvider.jsx";
// // const Management5 = () => {
// //   const [formData, setFormData] = useState({
// //     type: "",
// //     description: "",

// //     gole
// //       : "",
// //     startDate: "",
// //     endDate: "",
// //     discount: "",
// //     image: "",
// //   });

// //   const [couponRequests, setCouponRequests] = useState([]);
// //   const [showModal, setShowModal] = useState(false);
// //   const isMobile = window.innerWidth <= 768;
// //   const [payNowModal, setPayNowModal] = useState(false);
// //   const { showLoader, hideLoader } = useLoader();

// //   const [loading, setLoading] = useState(true);

// //   const tdStyle = {
// //     border: "1px solid #ccc",
// //     padding: "10px",
// //     textAlign: "center",
// //   };


// //   const [payNowAmount, setPayNowAmount] = useState(0);
// //   const [loadingPayNow, setLoadingPayNow] = useState(false);
// //   const [selectedCouponId, setSelectedCouponId] = useState(null);


// //   const handleRazorpayPayment = async () => {
// //     try {
// //       const vendorId = localStorage.getItem("vendorId");
// //       const token = localStorage.getItem("authToken");

// //       // ✅ Step 0: Fetch vendor details (ownerName, email, mobileNumber)
// //       const vendorRes = await axios.get(
// //         `https://backend.maamaas.com/food/api/vendors/${vendorId}`,
// //         { headers: { Authorization: `Bearer ${token}` } }
// //       );

// //       const vendorData = vendorRes.data;
// //       const vendorMobile =
// //         vendorData?.mobileNumber && vendorData.mobileNumber.toString().trim() !== ""
// //           ? vendorData.mobileNumber.toString()
// //           : "9999999999"; // fallback if missing

// //       const vendorName =
// //         vendorData?.ownerName && vendorData.ownerName.trim() !== ""
// //           ? vendorData.ownerName
// //           : "Vendor";

// //       const vendorEmail =
// //         vendorData?.email && vendorData.email.trim() !== ""
// //           ? vendorData.email
// //           : "vendor@example.com";

// //       // ✅ Step 1: Prepare payment details
// //       const payNowAmountInPaise = Math.round(payNowAmount);

// //       const username = "rzp_live_RU5whSMu9rPV7s"; // Razorpay test key
// //       const password = "khRC0vtSHCGHktyu62yekZp0"; // Razorpay test secret
// //       const basicAuth = btoa(`${username}:${password}`);

// //       // ✅ Step 2: Create Razorpay Order via backend
// //       const createOrderRes = await axios.post(
// //         "https://backend.maamaas.com/subscription/api/user/create-order",
// //         {
// //           amount: payNowAmountInPaise,
// //           currency: "INR",
// //           vendorId,
// //         },
// //         {
// //           headers: {
// //             Authorization: `Basic ${basicAuth}`,
// //             "Content-Type": "application/json",
// //           },
// //         }
// //       );

// //       const { orderId } = createOrderRes.data;
// //       if (!orderId) throw new Error("Order ID not received from backend");

// //       // ✅ Step 3: Open Razorpay Checkout
// //       const options = {
// //         key: username,
// //         amount: payNowAmountInPaise,
// //         currency: "INR",
// //         name: "Maamaa's",
// //         description: "Coupon Payment",
// //         order_id: orderId,
// //         handler: async (response) => {
// //           const paymentId = response.razorpay_payment_id;
// //           const razorpayOrderId = response.razorpay_order_id;

// //           if (!paymentId || !razorpayOrderId) {
// //             alert("⚠️ Payment ID or Order ID missing.");
// //             return;
// //           }

// //           try {
// //             // ✅ Step 4: Capture payment via backend
// //             await axios.post(
// //               "https://backend.maamaas.com/subscription/api/user/capture",
// //               {
// //                 paymentId,
// //                 amount: payNowAmountInPaise,
// //                 currency: "INR",
// //                 vendorId,
// //               },
// //               {
// //                 headers: { Authorization: `Basic ${basicAuth}` },
// //               }
// //             );

// //             // ✅ Step 5: Update internal backend
// //             await axios.put(
// //               `https://backend.maamaas.com/food/api/vendor/coupon/updatePayment`,
// //               {},
// //               {
// //                 params: {
// //                   vendorRequirementCouponId: selectedCouponId,
// //                   transactionId: paymentId,
// //                   orderId: razorpayOrderId,
// //                 },
// //                 headers: { Authorization: `Bearer ${token}` },
// //               }
// //             );

// //             alert("Payment successful and updated!");
// //             window.location.reload();
// //             setPayNowModal(false);
// //           } catch (captureError) {
// //             console.error("❌ Payment capture failed:", captureError);
// //             alert("Payment saved but capture failed.");
// //           }
// //         },
// //         prefill: {
// //           name: vendorName, // ✅ ownerName from backend
// //           email: vendorEmail, // ✅ email from backend
// //           contact: vendorMobile, // ✅ mobileNumber from backend (no +91)
// //         },
// //         theme: { color: "#b15cd6" },
// //       };

// //       const rzp = new window.Razorpay(options);
// //       rzp.open();
// //     } catch (error) {
// //       console.error("❌ Razorpay error:", error);
// //       alert("Payment failed to initialize.");
// //     }
// //   };


// //   const openPayNowModal = async (couponId) => {
// //     try {
// //       setLoadingPayNow(true);
// //       const token = localStorage.getItem("authToken");

// //       const response = await axios.get(
// //         `https://backend.maamaas.com/food/api/vendor/coupon/get/${couponId}`,
// //         { headers: { Authorization: `Bearer ${token}` } }
// //       );

// //       setPayNowAmount(response.data.amount || 0);
// //       setSelectedCouponId(couponId); // ✅ save for payment update
// //       setPayNowModal(true);
// //     } catch (error) {
// //       console.error("❌ Error fetching coupon amount:", error);
// //       alert("Failed to fetch coupon amount");
// //     } finally {
// //       setLoadingPayNow(false);
// //     }
// //   };



// //   // ✅ Fetch coupons on mount
// //   useEffect(() => {
// //     const fetchCoupons = async () => {
// //       try {
// //         showLoader();
// //         const token = localStorage.getItem("authToken");
// //         const vendorId = localStorage.getItem("vendorId");

// //         if (!token || !vendorId) {
// //           alert("Missing vendor session. Please log in again.");
// //           setLoading(false);
// //           return;
// //         }

// //         const response = await axios.get(
// //           `https://backend.maamaas.com/food/api/vendor/coupon/getByVendor/${vendorId}`,
// //           {
// //             headers: {
// //               Authorization: `Bearer ${token}`,
// //               Accept: "*/*",
// //             },
// //           }
// //         );

// //         // console.log("✅ Coupons fetched:", response.data);

// //         setCouponRequests(response.data || []);
// //       } catch (error) {
// //         console.error("❌ Error fetching coupons:", error);
// //         alert("Failed to fetch coupon requests");
// //       } finally {
// //         setLoading(false);
// //         hideLoader();
// //       }
// //     };

// //     fetchCoupons();
// //   }, []);

// //   const handleChange = (e) => {
// //     setFormData({ ...formData, [e.target.name]: e.target.value });
// //   };


// //   const handleImageUpload = (e) => {
// //     const file = e.target.files[0];
// //     if (!file) return;

// //     const reader = new FileReader();
// //     reader.onloadend = () => {
// //       let result = reader.result;

// //       // ✅ Ensure only base64 part (after comma)
// //       const base64Data = result.split(",")[1];

// //       setFormData((prev) => ({
// //         ...prev,
// //         image: base64Data, // pure base64 string only
// //       }));
// //     };
// //     reader.readAsDataURL(file);
// //   };


// //   const handleSubmit = async (e) => {
// //     e.preventDefault();

// //     try {
// //       let authtoken = localStorage.getItem("authToken");
// //       let vendorId = localStorage.getItem("vendorId");

// //       if (!authtoken || !vendorId) {
// //         alert("Missing vendor session. Please log in again.");
// //         return;
// //       }

// //       // ✅ Construct payload with all fields
// //       const newRequest = {
// //         vendorRequirementCouponId: 0,
// //         couponCode: formData.type?.toUpperCase().slice(0, 6) || "DEFAULT",
// //         discount: Number(formData.discount) || 0,
// //         startDate: new Date(formData.startDate).toISOString(),
// //         endDate: new Date(formData.endDate).toISOString(),
// //         description: formData.description || "",
// //         gole: formData.gole || "",
// //         amount: 0, // default if not needed
// //         paymentStatus: "PENDING",
// //         vendorId: "null",
// //         transactionId: "string",
// //         orderId: "string", // default placeholder
// //         image: formData.image || "", // ✅ base64 string
// //       };

// //       // console.log("📤 Sending payload:", newRequest);

// //       const response = await axios.post(
// //         `https://backend.maamaas.com/food/api/vendor/coupon/add/${vendorId}`,
// //         newRequest,
// //         {
// //           headers: {
// //             "Content-Type": "application/json",
// //             Authorization: `Bearer ${authtoken}`,
// //           },
// //         }
// //       );

// //       // console.log("✅ Coupon submitted:", response.data);
// //       window.location.reload();
// //       // Reset
// //       setFormData({
// //         type: "",
// //         description: "",
// //         goal: "",
// //         startDate: "",
// //         endDate: "",
// //         discount: "",
// //         image: "",
// //       });
// //       setShowModal(false);
// //     } catch (error) {
// //       console.error("❌ Error submitting coupon:", error.response?.data || error.message);
// //       alert("Failed to submit coupon. Please check server logs.");
// //     }
// //   };




// //   return (
// //     <div
// //       style={{
// //         // padding: '20px',
// //         maxWidth: '1200px',
// //         // margin: isMobile ? '38px 0 0 -29px' : 'auto',
// //         boxSizing: 'border-box',
// //         position: 'relative',
// //         width: '100%',
// //       }}
// //     >
// //       <div style={{
// //         display: 'flex',
// //         justifyContent: 'space-between',
// //         alignItems: 'center',
// //         marginBottom: '20px'
// //       }}>
// //         <button
// //           style={{
// //             padding: '10px 16px',
// //             backgroundColor: '#1976d2',
// //             color: '#fff',
// //             border: 'none',
// //             borderRadius: '6px',
// //             cursor: 'pointer',
// //             fontWeight: 'bold',
// //             fontSize: 'clamp(12px, 2vw, 14px)',
// //           }}
// //           onClick={() => setShowModal(true)}
// //         >
// //           + Request Coupon
// //         </button>
// //       </div>

// //       {/* Table Section */}
// //       <div style={{
// //         marginTop: '-15px',
// //         overflowX: 'auto',   // Horizontal scroll
// //         overflowY: 'auto',   // Vertical scroll
// //         width: window.innerWidth < 769 ? "90vw" : '100%',
// //         height: '60vh',
// //         scrollbarWidth: 'thin', // For Firefox
// //         msOverflowStyle: 'auto', // For IE/Edge
// //       }}
// //       >
// //         <div style={{
// //           minWidth: '800px',
// //           width: '100%'
// //         }}>
// //           <table
// //             style={{
// //               width: "100%",
// //               borderCollapse: "collapse",
// //               backgroundColor: "white",
// //               border: "1px solid rgba(204, 204, 204, 1)",
// //               marginTop: "0px",
// //             }}
// //           >
// //             <thead>
// //               <tr>
// //                 {[
// //                   "S.No",
// //                   "Type",
// //                   "Description",
// //                   "Image",
// //                   "Goal",
// //                   "Start Date",
// //                   "End Date",
// //                   "Discount",
// //                   "Amount",
// //                   "Status",
// //                   "Action",
// //                 ].map((head, i) => (
// //                   <th
// //                     key={i}
// //                     style={{
// //                       border: "1px solid #ccc",
// //                       padding: "10px",
// //                       backgroundColor: "#b15cd6",
// //                       fontSize: "clamp(10px, 2vw, 14px)",
// //                       textAlign: "center",
// //                       whiteSpace: "nowrap",
// //                     }}
// //                   >
// //                     {head}
// //                   </th>
// //                 ))}
// //               </tr>
// //             </thead>
// //             <tbody>
// //               {loading ? (
// //                 <tr>
// //                   <td colSpan="9" style={{ textAlign: "center", padding: "12px" }}>
// //                     Loading...
// //                   </td>
// //                 </tr>
// //               ) : couponRequests.length === 0 ? (
// //                 <tr>
// //                   <td colSpan="9" style={{ textAlign: "center", padding: "12px" }}>
// //                     No requests yet.
// //                   </td>
// //                 </tr>
// //               ) : (
// //                 couponRequests.map((request, index) => (
// //                   <tr key={index}>
// //                     <td style={{ ...tdStyle, fontSize: "clamp(10px, 2vw, 14px)" }}>
// //                       {index + 1}
// //                     </td>
// //                     <td style={{ ...tdStyle, fontSize: "clamp(10px, 2vw, 14px)" }}>
// //                       {request.couponCode}
// //                     </td>
// //                     <td style={{ ...tdStyle, fontSize: "clamp(10px, 2vw, 14px)" }}>
// //                       {request.description}
// //                     </td>
// //                     <td style={{ ...tdStyle, fontSize: "clamp(10px, 2vw, 14px)" }}>
// //                       {request.image ? (
// //                         <img
// //                           src={`data:image/png;base64,${request.image}`} // 👈 show base64 as image
// //                           alt="Coupon"
// //                           style={{
// //                             width: "60px",
// //                             height: "60px",
// //                             objectFit: "cover",
// //                             borderRadius: "6px",
// //                             border: "1px solid #ccc",
// //                           }}
// //                         />
// //                       ) : (
// //                         "No Image"
// //                       )}
// //                     </td>

// //                     <td style={{ ...tdStyle, fontSize: "clamp(10px, 2vw, 14px)" }}>
// //                       {request.gole || "N/A"}
// //                     </td>
// //                     <td style={{ ...tdStyle, fontSize: "clamp(10px, 2vw, 14px)" }}>
// //                       {request.startDate ? new Date(request.startDate).toLocaleDateString("en-GB") : "-"}
// //                     </td>
// //                     <td style={{ ...tdStyle, fontSize: "clamp(10px, 2vw, 14px)" }}>
// //                       {request.endDate ? new Date(request.endDate).toLocaleDateString("en-GB") : "-"}
// //                     </td>

// //                     <td style={{ ...tdStyle, fontSize: "clamp(10px, 2vw, 14px)" }}>
// //                       {request.discount}%
// //                     </td>
// //                     <td style={{ ...tdStyle, fontSize: "clamp(10px, 2vw, 14px)" }}>
// //                       {request.amount}
// //                     </td>
// //                     <td style={{ ...tdStyle, fontSize: "clamp(10px, 2vw, 14px)" }}>
// //                       {request.paymentStatus || "Pending"}
// //                     </td>
// //                     <td style={{ ...tdStyle, fontSize: "clamp(10px, 2vw, 14px)" }}>
// //                       {request.paymentStatus === "PAID" ? (
// //                         <button
// //                           style={{
// //                             backgroundColor: "gray",
// //                             color: "white",
// //                             border: "1px solid #ddd", // ✅ added border
// //                             padding: "6px 12px",
// //                             borderRadius: "6px",
// //                             cursor: "not-allowed",
// //                           }}
// //                           disabled
// //                         >
// //                           Paid
// //                         </button>
// //                       ) : (
// //                         <button
// //                           style={{
// //                             backgroundColor: "#b15cd6",
// //                             color: "white",
// //                             border: "1px solid #b15cd6", // ✅ added border matching button
// //                             padding: "6px 12px",
// //                             borderRadius: "6px",
// //                             cursor: "pointer",
// //                             whiteSpace: "nowrap",
// //                           }}
// //                           onClick={() => openPayNowModal(request.vendorRequirementCouponId)}
// //                         >
// //                           Pay Now
// //                         </button>
// //                       )}
// //                     </td>




// //                   </tr>
// //                 ))
// //               )}
// //             </tbody>
// //           </table>
// //         </div>
// //       </div>


// //       {payNowModal && (
// //         <div
// //           style={{
// //             position: 'fixed',
// //             top: 0,
// //             left: 0,
// //             height: '100vh',
// //             width: '100vw',
// //             backgroundColor: 'rgba(0,0,0,0.5)',
// //             display: 'flex',
// //             justifyContent: 'center',
// //             alignItems: 'center',
// //             zIndex: 1000,
// //           }}
// //         >
// //           <div
// //             style={{
// //               backgroundColor: '#fff',
// //               padding: '20px',
// //               borderRadius: '10px',
// //               width: '90%',
// //               maxWidth: '400px',
// //               boxSizing: 'border-box',
// //             }}
// //           >
// //             <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
// //               <h3 style={{ fontSize: 'clamp(16px, 3vw, 20px)', fontWeight: 'bold' }}>Pay Now</h3>
// //               <button
// //                 style={{
// //                   background: 'transparent',
// //                   border: 'none',
// //                   fontSize: '18px',
// //                   cursor: 'pointer',
// //                 }}
// //                 onClick={() => setPayNowModal(false)}
// //               >
// //                 ✕
// //               </button>
// //             </div>

// //             <div style={{ marginTop: '16px', display: 'flex', flexDirection: 'column', gap: '12px' }}>
// //               {loadingPayNow ? (
// //                 <p>Loading amount...</p>
// //               ) : (
// //                 <label style={labelStyle}>
// //                   Amount
// //                   <input
// //                     type="number"
// //                     value={payNowAmount}
// //                     readOnly
// //                     style={{ ...inputStyle, fontSize: 'clamp(12px, 2vw, 14px)' }}
// //                   />
// //                 </label>
// //               )}

// //               <button
// //                 style={{
// //                   padding: '12px',
// //                   backgroundColor: '#1976d2',
// //                   color: 'white',
// //                   fontWeight: 'bold',
// //                   border: 'none',
// //                   borderRadius: '6px',
// //                   cursor: 'pointer',
// //                   width: 'fit-content',
// //                   fontSize: 'clamp(12px, 2vw, 14px)'
// //                 }}
// //                 onClick={handleRazorpayPayment} // ✅ call payment function
// //               >
// //                 Proceed to Pay
// //               </button>

// //             </div>
// //           </div>
// //         </div>
// //       )}



// //       {/* Modal Popup */}
// //       {showModal && (
// //         <div
// //           style={{
// //             position: 'fixed',
// //             top: 0,
// //             left: 0,
// //             height: '100vh',
// //             width: '100vw',
// //             backgroundColor: 'rgba(0,0,0,0.5)',
// //             display: 'flex',
// //             justifyContent: 'center',
// //             alignItems: 'center',
// //             zIndex: 1000,
// //           }}
// //         >
// //           <div
// //             style={{
// //               backgroundColor: '#fff',
// //               padding: '20px',
// //               borderRadius: '10px',
// //               width: '90%',
// //               maxWidth: '600px',
// //               maxHeight: '90vh',
// //               overflowY: 'auto',
// //               boxSizing: 'border-box',
// //             }}
// //           >
// //             <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
// //               <h3 style={{ fontSize: 'clamp(16px, 3vw, 20px)', fontWeight: 'bold' }}>Request a Coupon</h3>
// //               <button
// //                 style={{
// //                   background: 'transparent',
// //                   border: 'none',
// //                   fontSize: '18px',
// //                   cursor: 'pointer',
// //                 }}
// //                 onClick={() => setShowModal(false)}
// //               >
// //                 ✕
// //               </button>
// //             </div>

// //             <form onSubmit={handleSubmit} style={{
// //               display: 'flex',
// //               flexDirection: 'column',
// //               gap: '12px',
// //               marginTop: '16px'
// //             }}>
// //               <input
// //                 type="text"
// //                 name="type"
// //                 placeholder="Coupon Type"
// //                 value={formData.type}
// //                 onChange={handleChange}
// //                 required
// //                 style={{ ...inputStyle, fontSize: 'clamp(12px, 2vw, 14px)' }}
// //               />
// //               <textarea
// //                 name="description"
// //                 placeholder="Description"
// //                 value={formData.description}
// //                 onChange={handleChange}
// //                 rows="3"
// //                 required
// //                 style={{ ...inputStyle, resize: 'vertical', fontSize: 'clamp(12px, 2vw, 14px)' }}
// //               />
// //               <input
// //                 type="text"
// //                 name="gole"
// //                 placeholder="Goal (e.g., Increase Leads)"
// //                 value={formData.gole}
// //                 onChange={handleChange}
// //                 required
// //                 style={{ ...inputStyle, fontSize: 'clamp(12px, 2vw, 14px)' }}
// //               />

// //               <div style={{
// //                 display: 'flex',
// //                 flexDirection: window.innerWidth < 480 ? 'column' : 'row',
// //                 gap: '12px'
// //               }}>
// //                 <div style={{ flex: 1 }}>
// //                   <label style={labelStyle}>
// //                     Start Date
// //                     <input
// //                       type="date"
// //                       name="startDate"
// //                       value={formData.startDate}
// //                       min={new Date().toISOString().split('T')[0]} // Add this line
// //                       onChange={handleChange}
// //                       required
// //                       style={{ ...inputStyle, fontSize: 'clamp(12px, 2vw, 14px)' }}
// //                     />
// //                   </label>
// //                 </div>
// //                 <div style={{ flex: 1 }}>
// //                   <label style={labelStyle}>
// //                     End Date
// //                     <input
// //                       type="date"
// //                       name="endDate"
// //                       value={formData.endDate}
// //                       onChange={handleChange}
// //                       min={formData.startDate || new Date().toISOString().split('T')[0]}
// //                       required
// //                       style={{ ...inputStyle, fontSize: 'clamp(12px, 2vw, 14px)' }}
// //                     />
// //                   </label>
// //                 </div>
// //               </div>

// //               <input
// //                 type="number"
// //                 name="discount"
// //                 placeholder="Discount (%)"
// //                 value={formData.discount}
// //                 onChange={handleChange}
// //                 required
// //                 style={{ ...inputStyle, fontSize: 'clamp(12px, 2vw, 14px)' }}
// //               />
// //               <input
// //                 type="file"
// //                 accept="image/*"
// //                 onChange={handleImageUpload}
// //                 style={{ ...inputStyle, fontSize: 'clamp(12px, 2vw, 14px)' }}
// //               />

// //               <button
// //                 type="submit"
// //                 style={{
// //                   padding: '12px',
// //                   backgroundColor: '#1976d2',
// //                   color: 'white',
// //                   fontWeight: 'bold',
// //                   border: 'none',
// //                   borderRadius: '6px',
// //                   cursor: 'pointer',
// //                   width: 'fit-content',
// //                   fontSize: 'clamp(12px, 2vw, 14px)'
// //                 }}
// //               >
// //                 Submit Request
// //               </button>
// //             </form>
// //           </div>
// //         </div>
// //       )}
// //     </div>
// //   );
// // };

// // // Reusable styles
// // const inputStyle = {
// //   padding: '10px',
// //   border: '1px solid #ccc',
// //   borderRadius: '6px',
// //   width: '100%',
// //   boxSizing: 'border-box',
// // };

// // const labelStyle = {
// //   fontSize: 'clamp(12px, 2vw, 14px)',
// //   marginBottom: '4px',
// //   display: 'block',
// // };

// // const tdStyle = {
// //   padding: '10px',
// //   border: '1px solid #ccc',
// //   textAlign: 'left',
// // };

// // export default Management5;





// import React, { useEffect, useState, useCallback } from "react";
// import axios from "axios";
// import { useLoader } from "../../../../context/LoaderProvider.jsx";

// const Management5 = () => {
//   const [formData, setFormData] = useState({
//     type: "",
//     description: "",
//     goal: "",
//     startDate: "",
//     endDate: "",
//     discount: "",
//     discountType: "PERCENTAGE",
//     couponType: "FLAT",
//     minimumOrderValue: "",
//     image: "",
//   });

//   const [couponRequests, setCouponRequests] = useState([]);
//   const [showModal, setShowModal] = useState(false);
//   const [payNowModal, setPayNowModal] = useState(false);
//   const { showLoader, hideLoader } = useLoader();
//   const [loading, setLoading] = useState(true);
//   const [payNowAmount, setPayNowAmount] = useState(0);
//   const [loadingPayNow, setLoadingPayNow] = useState(false);
//   const [selectedCouponId, setSelectedCouponId] = useState(null);

//   // ✅ Fetch coupons function
//   const fetchCoupons = useCallback(async () => {
//     try {
//       // showLoader();
//       const token = localStorage.getItem("authToken");
//       const vendorId = localStorage.getItem("vendorId");

//       if (!token || !vendorId) {
//         alert("Missing vendor session. Please log in again.");
//         setLoading(false);
//         return;
//       }

//       const response = await axios.get(
//         `https://backend.maamaas.com/food/api/vendor/coupon/getByVendor/${vendorId}`,
//         {
//           headers: {
//             Authorization: `Bearer ${token}`,
//             Accept: "*/*",
//           },
//         }
//       );

//       setCouponRequests(response.data || []);
//     } catch (error) {
//       console.error("❌ Error fetching coupons:", error);
//       alert("Failed to fetch coupon requests");
//     } finally {
//       setLoading(false);
//       // hideLoader();
//     }
//   }, []);

//   // ✅ Fetch coupons on mount
//   useEffect(() => {
//     fetchCoupons();
//   }, [fetchCoupons]);

//   // ✅ Handle form changes with conditional logic
//   const handleChange = (e) => {
//     const { name, value } = e.target;
    
//     setFormData(prev => {
//       const updated = { ...prev, [name]: value };
      
//       // Reset minimumOrderValue if couponType changes from UPTO to FLAT
//       if (name === "couponType" && value === "FLAT") {
//         updated.minimumOrderValue = "";
//       }
      
//       return updated;
//     });
//   };

//   // ✅ Handle image upload
//   const handleImageUpload = (e) => {
//     const file = e.target.files[0];
//     if (!file) return;

//     // Validate file size (max 2MB)
//     if (file.size > 2 * 1024 * 1024) {
//       alert("Image size should be less than 2MB");
//       return;
//     }

//     // Validate file type
//     if (!file.type.startsWith('image/')) {
//       alert("Please upload an image file");
//       return;
//     }

//     const reader = new FileReader();
//     reader.onloadend = () => {
//       const result = reader.result;
//       const base64Data = result.split(",")[1] || result;
//       setFormData(prev => ({
//         ...prev,
//         image: base64Data,
//       }));
//     };
//     reader.readAsDataURL(file);
//   };

//   // ✅ Form validation
//   const validateForm = () => {
//     // Check required fields
//     if (!formData.type.trim()) {
//       alert("Coupon name is required");
//       return false;
//     }

//     if (!formData.discount.trim()) {
//       alert("Discount amount is required");
//       return false;
//     }

//     // Validate discount based on discountType
//     const discountValue = parseFloat(formData.discount);
    
//     if (formData.discountType === "PERCENTAGE") {
//       if (discountValue < 0 || discountValue > 100) {
//         alert("Percentage discount must be between 0 and 100");
//         return false;
//       }
//     } else if (formData.discountType === "FIXED_AMOUNT") {
//       if (discountValue < 0) {
//         alert("Fixed amount discount cannot be negative");
//         return false;
//       }
//       if (discountValue > 10000) {
//         alert("Fixed amount discount is too high (max: ₹10000)");
//         return false;
//       }
//     }

//     // Validate dates
//     if (!formData.startDate || !formData.endDate) {
//       alert("Please select both start and end dates");
//       return false;
//     }

//     const startDate = new Date(formData.startDate);
//     const endDate = new Date(formData.endDate);
//     const today = new Date();
//     today.setHours(0, 0, 0, 0);

//     if (startDate < today) {
//       alert("Start date cannot be in the past");
//       return false;
//     }

//     if (endDate <= startDate) {
//       alert("End date must be after start date");
//       return false;
//     }

//     // Validate minimumOrderValue for UPTO coupon type
//     if (formData.couponType === "UPTO") {
//       const minOrderValue = parseFloat(formData.minimumOrderValue);
//       if (!minOrderValue || minOrderValue <= 0) {
//         alert("Minimum order value is required for 'UPTO' coupon type");
//         return false;
//       }
//     }

//     return true;
//   };

//   // ✅ Handle form submission
//   const handleSubmit = async (e) => {
//     e.preventDefault();

//     if (!validateForm()) {
//       return;
//     }

//     try {
//       const token = localStorage.getItem("authToken");
//       const vendorId = localStorage.getItem("vendorId");

//       if (!token || !vendorId) {
//         alert("Missing vendor session. Please log in again.");
//         return;
//       }

//       // Generate coupon code from type (first 6 chars uppercase)
//       const couponCode = formData.type
//         .toUpperCase()
//         .replace(/\s+/g, '')
//         .slice(0, 6);

//       // Prepare payload matching API structure
//       const payload = {
//         vendorRequirementCouponId: 0,
//         couponCode: couponCode || "DEFAULT",
//         discount: parseFloat(formData.discount) || 0,
//         discountType: formData.discountType,
//         couponType: formData.couponType,
//         startDate: new Date(formData.startDate).toISOString(),
//         endDate: new Date(formData.endDate).toISOString(),
//         description: formData.description || "",
//         gole: formData.goal || "", // API field name is "gole" (backend typo)
//         minimumOrderValue: formData.couponType === "UPTO" 
//           ? parseFloat(formData.minimumOrderValue) || 0 
//           : 0,
//         amount: 0,
//         paymentStatus: "PENDING",
//         vendorId: parseInt(vendorId) || 0,
//         transactionId: "",
//         orderId: "",
//         image: formData.image || "",
//       };

//       const response = await axios.post(
//         `https://backend.maamaas.com/food/api/vendor/coupon/add/${vendorId}`,
//         payload,
//         {
//           headers: {
//             "Content-Type": "application/json",
//             Authorization: `Bearer ${token}`,
//           },
//         }
//       );

//       alert("Coupon request submitted successfully!");
      
//       // Reset form
//       setFormData({
//         type: "",
//         description: "",
//         goal: "",
//         startDate: "",
//         endDate: "",
//         discount: "",
//         discountType: "PERCENTAGE",
//         couponType: "FLAT",
//         minimumOrderValue: "",
//         image: "",
//       });
      
//       // Close modal and refresh data
//       setShowModal(false);
//       fetchCoupons();

//     } catch (error) {
//       console.error("❌ Error submitting coupon:", error);
//       alert(`Failed to submit coupon: ${error.response?.data?.message || error.message}`);
//     }
//   };

//   // ✅ Open Pay Now Modal
//   const openPayNowModal = async (couponId) => {
//     try {
//       setLoadingPayNow(true);
//       const token = localStorage.getItem("authToken");

//       const response = await axios.get(
//         `https://backend.maamaas.com/food/api/vendor/coupon/get/${couponId}`,
//         { headers: { Authorization: `Bearer ${token}` } }
//       );

//       setPayNowAmount(response.data.amount || 0);
//       setSelectedCouponId(couponId);
//       setPayNowModal(true);
//     } catch (error) {
//       console.error("❌ Error fetching coupon amount:", error);
//       alert("Failed to fetch coupon amount");
//     } finally {
//       setLoadingPayNow(false);
//     }
//   };

//   // ✅ Handle Razorpay Payment
//   const handleRazorpayPayment = async () => {
//     try {
//       const vendorId = localStorage.getItem("vendorId");
//       const token = localStorage.getItem("authToken");

//       // Fetch vendor details
//       const vendorRes = await axios.get(
//         `https://backend.maamaas.com/food/api/vendors/${vendorId}`,
//         { headers: { Authorization: `Bearer ${token}` } }
//       );

//       const vendorData = vendorRes.data;
//       const vendorMobile = vendorData?.mobileNumber?.toString().trim() || "9999999999";
//       const vendorName = vendorData?.ownerName?.trim() || "Vendor";
//       const vendorEmail = vendorData?.email?.trim() || "vendor@example.com";

//       // Prepare payment details
//       const payNowAmountInPaise = Math.round(payNowAmount * 100); // Convert to paise

//       const username = "rzp_live_RU5whSMu9rPV7s"; // ⚠️ SECURITY: Move to backend
//       const password = "khRC0vtSHCGHktyu62yekZp0"; // ⚠️ SECURITY: Move to backend
//       const basicAuth = btoa(`${username}:${password}`);

//       // Create Razorpay Order
//       const createOrderRes = await axios.post(
//         "https://backend.maamaas.com/subscription/api/user/create-order",
//         {
//           amount: payNowAmountInPaise,
//           currency: "INR",
//           vendorId,
//         },
//         {
//           headers: {
//             Authorization: `Basic ${basicAuth}`,
//             "Content-Type": "application/json",
//           },
//         }
//       );

//       const { orderId } = createOrderRes.data;
//       if (!orderId) throw new Error("Order ID not received");

//       // Open Razorpay Checkout
//       const options = {
//         key: username,
//         amount: payNowAmountInPaise,
//         currency: "INR",
//         name: "Maamaa's",
//         description: "Coupon Payment",
//         order_id: orderId,
//         handler: async (response) => {
//           const paymentId = response.razorpay_payment_id;
//           const razorpayOrderId = response.razorpay_order_id;

//           if (!paymentId || !razorpayOrderId) {
//             alert("⚠️ Payment ID or Order ID missing.");
//             return;
//           }

//           try {
//             // Capture payment
//             await axios.post(
//               "https://backend.maamaas.com/subscription/api/user/capture",
//               {
//                 paymentId,
//                 amount: payNowAmountInPaise,
//                 currency: "INR",
//                 vendorId,
//               },
//               {
//                 headers: { Authorization: `Basic ${basicAuth}` },
//               }
//             );

//             // Update internal backend
//             await axios.put(
//               `https://backend.maamaas.com/food/api/vendor/coupon/updatePayment`,
//               {},
//               {
//                 params: {
//                   vendorRequirementCouponId: selectedCouponId,
//                   transactionId: paymentId,
//                   orderId: razorpayOrderId,
//                 },
//                 headers: { Authorization: `Bearer ${token}` },
//               }
//             );

//             alert("Payment successful and updated!");
//             fetchCoupons();
//             setPayNowModal(false);
//           } catch (captureError) {
//             console.error("❌ Payment capture failed:", captureError);
//             alert("Payment saved but capture failed.");
//           }
//         },
//         prefill: {
//           name: vendorName,
//           email: vendorEmail,
//           contact: vendorMobile,
//         },
//         theme: { color: "#b15cd6" },
//       };

//       const rzp = new window.Razorpay(options);
//       rzp.open();
//     } catch (error) {
//       console.error("❌ Razorpay error:", error);
//       alert("Payment failed to initialize.");
//     }
//   };

//   // ✅ Styles
//   const tableHeaderStyle = {
//     border: "1px solid #ccc",
//     padding: "10px",
//     backgroundColor: "#b15cd6",
//     fontSize: "clamp(10px, 2vw, 14px)",
//     textAlign: "center",
//     whiteSpace: "nowrap",
//   };

//   const tableCellStyle = {
//     border: "1px solid #ccc",
//     padding: "10px",
//     textAlign: "center",
//     fontSize: "clamp(10px, 2vw, 14px)",
//   };

//   const imageStyle = {
//     width: "60px",
//     height: "60px",
//     objectFit: "cover",
//     borderRadius: "6px",
//     border: "1px solid #ccc",
//   };

//   const paidButtonStyle = {
//     backgroundColor: "gray",
//     color: "white",
//     border: "1px solid #ddd",
//     padding: "6px 12px",
//     borderRadius: "6px",
//     cursor: "not-allowed",
//   };

//   const payButtonStyle = {
//     backgroundColor: "#b15cd6",
//     color: "white",
//     border: "1px solid #b15cd6",
//     padding: "6px 12px",
//     borderRadius: "6px",
//     cursor: "pointer",
//     whiteSpace: "nowrap",
//   };

//   const inputStyle = {
//     padding: '10px',
//     border: '1px solid #ccc',
//     borderRadius: '6px',
//     width: '100%',
//     boxSizing: 'border-box',
//     fontSize: '14px',
//   };

//   const selectStyle = {
//     ...inputStyle,
//     backgroundColor: 'white',
//   };

//   const labelStyle = {
//     display: 'block',
//     marginBottom: '5px',
//     fontWeight: 'bold',
//     fontSize: '14px',
//   };

//   const modalOverlayStyle = {
//     position: 'fixed',
//     top: 0,
//     left: 0,
//     height: '100vh',
//     width: '100vw',
//     backgroundColor: 'rgba(0,0,0,0.5)',
//     display: 'flex',
//     justifyContent: 'center',
//     alignItems: 'center',
//     zIndex: 1000,
//   };

//   const modalContentStyle = {
//     backgroundColor: '#fff',
//     padding: '20px',
//     borderRadius: '10px',
//     width: '90%',
//     maxWidth: '500px',
//     maxHeight: '70vh',
//     overflowY: 'auto',
//     boxSizing: 'border-box',
//   };

//   const modalHeaderStyle = {
//     display: 'flex',
//     justifyContent: 'space-between',
//     alignItems: 'center',
//     marginBottom: '20px',
//   };

//   const formGroupStyle = {
//     marginBottom: '15px',
//   };

//   const isMobile = window.innerWidth <= 768;

//   return (
//     <div
//       style={{
//         maxWidth: '1200px',
//         width: '100%',
//         position: 'relative',
//       }}
//     >
//       {/* Header with Add Button */}
//       <div style={{
//         display: 'flex',
//         justifyContent: 'space-between',
//         alignItems: 'center',
//         marginBottom: '20px'
//       }}>
//         <button
//           style={{
//             padding: '10px 16px',
//             backgroundColor: '#1976d2',
//             color: '#fff',
//             border: 'none',
//             borderRadius: '6px',
//             cursor: 'pointer',
//             fontWeight: 'bold',
//             fontSize: 'clamp(12px, 2vw, 14px)',
//           }}
//           onClick={() => setShowModal(true)}
//         >
//           + Request Coupon
//         </button>
//       </div>

//       {/* Table Section */}
//       <div style={{
//         marginTop: '-15px',
//         overflowX: 'auto',
//         overflowY: 'auto',
//         width: isMobile ? "90vw" : '100%',
//         height: '60vh',
//         scrollbarWidth: 'thin',
//       }}>
//         <div style={{ minWidth: '1000px', width: '100%' }}>
//           <table
//             style={{
//               width: "100%",
//               borderCollapse: "collapse",
//               backgroundColor: "white",
//               border: "1px solid rgba(204, 204, 204, 1)",
//               marginTop: "0px",
//             }}
//           >
//             <thead>
//               <tr>
//                 {[
//                   "S.No",
//                   "Coupon Code",
//                   "Coupon Type",
//                   "Discount Type",
//                   "Description",
//                   "Image",
//                   "Goal",
//                   "Min Order",
//                   "Start Date",
//                   "End Date",
//                   "Discount",
//                   "Amount",
//                   "Status",
//                   "Action",
//                 ].map((head, i) => (
//                   <th key={i} style={tableHeaderStyle}>
//                     {head}
//                   </th>
//                 ))}
//               </tr>
//             </thead>
//             <tbody>
//               {loading ? (
//                 <tr>
//                   <td colSpan="14" style={{ textAlign: "center", padding: "12px" }}>
//                     Loading...
//                   </td>
//                 </tr>
//               ) : couponRequests.length === 0 ? (
//                 <tr>
//                   <td colSpan="14" style={{ textAlign: "center", padding: "12px" }}>
//                     No coupon requests yet.
//                   </td>
//                 </tr>
//               ) : (
//                 couponRequests.map((request, index) => (
//                   <tr key={index}>
//                     <td style={tableCellStyle}>{index + 1}</td>
//                     <td style={tableCellStyle}>{request.couponCode}</td>
//                     <td style={tableCellStyle}>
//                       {request.couponType === "UPTO" ? "Upto" : "Flat"}
//                     </td>
//                     <td style={tableCellStyle}>
//                       {request.discountType === "PERCENTAGE" ? "Percentage" : "Fixed Amount"}
//                     </td>
//                     <td style={tableCellStyle}>{request.description}</td>
//                     <td style={tableCellStyle}>
//                       {request.image ? (
//                         <img
//                           src={`data:image/png;base64,${request.image}`}
//                           alt="Coupon"
//                           style={imageStyle}
//                         />
//                       ) : (
//                         "No Image"
//                       )}
//                     </td>
//                     <td style={tableCellStyle}>{request.gole || "N/A"}</td>
//                     <td style={tableCellStyle}>
//                       {request.minimumOrderValue > 0 
//                         ? `₹${request.minimumOrderValue}` 
//                         : "N/A"}
//                     </td>
//                     <td style={tableCellStyle}>
//                       {request.startDate ? new Date(request.startDate).toLocaleDateString("en-GB") : "-"}
//                     </td>
//                     <td style={tableCellStyle}>
//                       {request.endDate ? new Date(request.endDate).toLocaleDateString("en-GB") : "-"}
//                     </td>
//                     <td style={tableCellStyle}>
//                       {request.discountType === "PERCENTAGE" 
//                         ? `${request.discount}%` 
//                         : `₹${request.discount}`}
//                     </td>
//                     <td style={tableCellStyle}>₹{request.amount}</td>
//                     <td style={tableCellStyle}>
//                       <span style={{
//                         padding: '4px 8px',
//                         borderRadius: '12px',
//                         fontSize: '12px',
//                         fontWeight: 'bold',
//                         backgroundColor: request.paymentStatus === "PAID" ? '#d4edda' : '#f8d7da',
//                         color: request.paymentStatus === "PAID" ? '#155724' : '#721c24',
//                       }}>
//                         {request.paymentStatus}
//                       </span>
//                     </td>
//                     <td style={tableCellStyle}>
//                       {request.paymentStatus === "PAID" ? (
//                         <button style={paidButtonStyle} disabled>
//                           Paid
//                         </button>
//                       ) : (
//                         <button 
//                           style={payButtonStyle}
//                           onClick={() => openPayNowModal(request.vendorRequirementCouponId)}
//                         >
//                           Pay Now
//                         </button>
//                       )}
//                     </td>
//                   </tr>
//                 ))
//               )}
//             </tbody>
//           </table>
//         </div>
//       </div>

//       {/* Pay Now Modal */}
//       {payNowModal && (
//         <div style={modalOverlayStyle}>
//           <div style={modalContentStyle}>
//             <div style={modalHeaderStyle}>
//               <h3 style={{ fontSize: 'clamp(16px, 3vw, 20px)', fontWeight: 'bold' }}>Pay Now</h3>
//               <button
//                 style={{
//                   background: 'transparent',
//                   border: 'none',
//                   fontSize: '18px',
//                   cursor: 'pointer',
//                 }}
//                 onClick={() => setPayNowModal(false)}
//               >
//                 ✕
//               </button>
//             </div>

//             <div style={{ marginTop: '16px', display: 'flex', flexDirection: 'column', gap: '12px' }}>
//               {loadingPayNow ? (
//                 <p>Loading amount...</p>
//               ) : (
//                 <label style={labelStyle}>
//                   Amount
//                   <input
//                     type="number"
//                     value={payNowAmount}
//                     readOnly
//                     style={{ ...inputStyle, fontSize: 'clamp(12px, 2vw, 14px)' }}
//                   />
//                 </label>
//               )}

//               <button
//                 style={{
//                   padding: '12px',
//                   backgroundColor: '#1976d2',
//                   color: 'white',
//                   fontWeight: 'bold',
//                   border: 'none',
//                   borderRadius: '6px',
//                   cursor: 'pointer',
//                   width: 'fit-content',
//                   fontSize: 'clamp(12px, 2vw, 14px)'
//                 }}
//                 onClick={handleRazorpayPayment}
//               >
//                 Proceed to Pay
//               </button>
//             </div>
//           </div>
//         </div>
//       )}

//       {/* Add Coupon Modal */}
//       {showModal && (
//         <div style={modalOverlayStyle}>
//           <div style={modalContentStyle}>
//             <div style={modalHeaderStyle}>
//               <h3 style={{ fontSize: 'clamp(16px, 3vw, 20px)', fontWeight: 'bold' }}>Request a Coupon</h3>
//               <button
//                 style={{
//                   background: 'transparent',
//                   border: 'none',
//                   fontSize: '18px',
//                   cursor: 'pointer',
//                 }}
//                 onClick={() => setShowModal(false)}
//               >
//                 ✕
//               </button>
//             </div>

//             <form onSubmit={handleSubmit} style={{
//               display: 'flex',
//               flexDirection: 'column',
//               gap: '12px',
//               marginTop: '16px'
//             }}>
//               {/* Coupon Name */}
//               <div style={formGroupStyle}>
//                 <label style={labelStyle}>Coupon Code *</label>
//                 <input
//                   type="text"
//                   name="type"
//                   value={formData.type}
//                   onChange={handleChange}
//                   required
//                   style={inputStyle}
//                 />
               
//               </div>

//               {/* Coupon Type */}
//               <div style={formGroupStyle}>
//                 <label style={labelStyle}>Coupon Type *</label>
//                 <select
//                   name="couponType"
//                   value={formData.couponType}
//                   onChange={handleChange}
//                   required
//                   style={selectStyle}
//                 >
//                   <option value="FLAT">Flat Discount</option>
//                   <option value="UPTO">Upto Discount</option>
//                 </select>
//                 <small style={{ fontSize: '12px', color: '#666' }}>
//                   {formData.couponType === "UPTO" 
//                     ? "Discount applies only when order value exceeds minimum amount" 
//                     : "Discount applies to all orders"}
//                 </small>
//               </div>

//               {/* Discount Type */}
//               <div style={formGroupStyle}>
//                 <label style={labelStyle}>Discount Type *</label>
//                 <select
//                   name="discountType"
//                   value={formData.discountType}
//                   onChange={handleChange}
//                   required
//                   style={selectStyle}
//                 >
//                   <option value="PERCENTAGE">Percentage (%)</option>
//                   <option value="FIXED_AMOUNT">Fixed Amount (₹)</option>
//                 </select>
//               </div>

//               {/* Discount Amount */}
//               <div style={formGroupStyle}>
//                 <label style={labelStyle}>
//                   {formData.discountType === "PERCENTAGE" 
//                     ? "Discount Percentage *" 
//                     : "Discount Amount (₹) *"}
//                 </label>
//                 <input
//                   type="number"
//                   name="discount"
//                   placeholder={formData.discountType === "PERCENTAGE" ? "10" : "100"}
//                   value={formData.discount}
//                   onChange={handleChange}
//                   min="0"
//                   max={formData.discountType === "PERCENTAGE" ? "100" : "10000"}
//                   step="0.01"
//                   required
//                   style={inputStyle}
//                 />
                
//               </div>

//               {/* Minimum Order Value (Only for UPTO coupon type) */}
//               {formData.couponType === "UPTO" && (
//                 <div style={formGroupStyle}>
//                   <label style={labelStyle}>Minimum Order Value (₹) *</label>
//                   <input
//                     type="number"
//                     name="minimumOrderValue"
//                     placeholder="e.g., 500"
//                     value={formData.minimumOrderValue}
//                     onChange={handleChange}
//                     min="1"
//                     required
//                     style={inputStyle}
//                   />
//                   <small style={{ fontSize: '12px', color: '#666' }}>
//                     Discount will apply only when order value exceeds this amount
//                   </small>
//                 </div>
//               )}

//               {/* Goal */}
//               <div style={formGroupStyle}>
//                 <label style={labelStyle}>Goal *</label>
//                 <input
//                   type="text"
//                   name="goal"
//                   value={formData.goal}
//                   onChange={handleChange}
//                   required
//                   style={inputStyle}
//                 />
//               </div>

//               {/* Description */}
//               <div style={formGroupStyle}>
//                 <label style={labelStyle}>Description *</label>
//                 <textarea
//                   name="description"
//                   placeholder="Describe this coupon offer in detail..."
//                   value={formData.description}
//                   onChange={handleChange}
//                   rows="3"
//                   required
//                   style={{ ...inputStyle, minHeight: '80px', resize: 'vertical' }}
//                 />
//               </div>

//               {/* Dates */}
//               <div style={{
//                 display: 'flex',
//                 flexDirection: isMobile ? 'column' : 'row',
//                 gap: '12px'
//               }}>
//                 <div style={{ flex: 1 }}>
//                   <label style={labelStyle}>Start Date *</label>
//                   <input
//                     type="date"
//                     name="startDate"
//                     value={formData.startDate}
//                     min={new Date().toISOString().split('T')[0]}
//                     onChange={handleChange}
//                     required
//                     style={inputStyle}
//                   />
//                 </div>
//                 <div style={{ flex: 1 }}>
//                   <label style={labelStyle}>End Date *</label>
//                   <input
//                     type="date"
//                     name="endDate"
//                     value={formData.endDate}
//                     min={formData.startDate || new Date().toISOString().split('T')[0]}
//                     onChange={handleChange}
//                     required
//                     style={inputStyle}
//                   />
//                 </div>
//               </div>

//               {/* Image Upload */}
//               <div style={formGroupStyle}>
//                 <label style={labelStyle}>Coupon Banner Image</label>
//                 <input
//                   type="file"
//                   accept="image/*"
//                   onChange={handleImageUpload}
//                   style={inputStyle}
//                 />
//                 {formData.image && (
//                   <div style={{ marginTop: '10px' }}>
//                     <img
//                       src={`data:image/png;base64,${formData.image}`}
//                       alt="Preview"
//                       style={{
//                         width: '100px',
//                         height: '100px',
//                         objectFit: 'cover',
//                         borderRadius: '6px',
//                         border: '1px solid #ddd',
//                       }}
//                     />
//                   </div>
//                 )}
//               </div>

//               <button
//                 type="submit"
//                 style={{
//                   padding: '12px',
//                   backgroundColor: '#1976d2',
//                   color: 'white',
//                   fontWeight: 'bold',
//                   border: 'none',
//                   borderRadius: '6px',
//                   cursor: 'pointer',
//                   width: 'fit-content',
//                   fontSize: 'clamp(12px, 2vw, 14px)'
//                 }}
//               >
//                 Submit Coupon Request
//               </button>
//             </form>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };

// export default Management5;




import React, { useEffect, useState, useCallback } from "react";
import axios from "axios";
import { useLoader } from "../../../../context/LoaderProvider.jsx";
import { color } from "framer-motion";

const Management5 = () => {
  const [formData, setFormData] = useState({
    type: "",
    description: "",
    goal: "",
    startDate: "",
    endDate: "",
    discount: "",
    discountType: "PERCENTAGE",
    couponType: "FLAT",
    minimumOrderValue: "",
    imageFile: null, // Changed from image string to File object
  });

  const [couponRequests, setCouponRequests] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [payNowModal, setPayNowModal] = useState(false);
  const { showLoader, hideLoader } = useLoader();
  const [loading, setLoading] = useState(true);
  const [payNowAmount, setPayNowAmount] = useState(0);
  const [loadingPayNow, setLoadingPayNow] = useState(false);
  const [selectedCouponId, setSelectedCouponId] = useState(null);
  const [imagePreview, setImagePreview] = useState(null); // For preview URL

  // ✅ Fetch coupons function
  const fetchCoupons = useCallback(async () => {
    try {
      const token = localStorage.getItem("authToken");
      const vendorId = localStorage.getItem("vendorId");

      if (!token || !vendorId) {
        alert("Missing vendor session. Please log in again.");
        setLoading(false);
        return;
      }

      const response = await axios.get(
        `https://backend.maamaas.com/food/api/vendor/coupon/getByVendor/${vendorId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            Accept: "*/*",
          },
        }
      );

      setCouponRequests(response.data || []);
    } catch (error) {
      console.error("❌ Error fetching coupons:", error);
      alert("Failed to fetch coupon requests");
    } finally {
      setLoading(false);
    }
  }, []);

  // ✅ Fetch coupons on mount
  useEffect(() => {
    fetchCoupons();
  }, [fetchCoupons]);

  // ✅ Handle form changes with conditional logic
  const handleChange = (e) => {
    const { name, value } = e.target;
    
    setFormData(prev => {
      const updated = { ...prev, [name]: value };
      
      // Reset minimumOrderValue if couponType changes from UPTO to FLAT
      if (name === "couponType" && value === "FLAT") {
        updated.minimumOrderValue = "";
      }
      
      return updated;
    });
  };

  // ✅ Handle image upload - MULTIPART/FORM-DATA VERSION
  const handleImageUpload = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    // Validate file size (max 2MB)
    if (file.size > 2 * 1024 * 1024) {
      alert("Image size should be less than 2MB");
      return;
    }

    // Validate file type
    if (!file.type.startsWith('image/')) {
      alert("Please upload an image file");
      return;
    }

    // Store file object and create preview URL
    setFormData(prev => ({
      ...prev,
      imageFile: file
    }));

    // Create preview URL
    const previewUrl = URL.createObjectURL(file);
    setImagePreview(previewUrl);
  };

  // Cleanup preview URL on unmount
  useEffect(() => {
    return () => {
      if (imagePreview) {
        URL.revokeObjectURL(imagePreview);
      }
    };
  }, [imagePreview]);

  // ✅ Form validation
  const validateForm = () => {
    // Check required fields
    if (!formData.type.trim()) {
      alert("Coupon name is required");
      return false;
    }

    if (!formData.discount.trim()) {
      alert("Discount amount is required");
      return false;
    }

    // Validate discount based on discountType
    const discountValue = parseFloat(formData.discount);
    
    if (formData.discountType === "PERCENTAGE") {
      if (discountValue < 0 || discountValue > 100) {
        alert("Percentage discount must be between 0 and 100");
        return false;
      }
    } else if (formData.discountType === "FIXED_AMOUNT") {
      if (discountValue < 0) {
        alert("Fixed amount discount cannot be negative");
        return false;
      }
      if (discountValue > 10000) {
        alert("Fixed amount discount is too high (max: ₹10000)");
        return false;
      }
    }

    // Validate dates
    if (!formData.startDate || !formData.endDate) {
      alert("Please select both start and end dates");
      return false;
    }

    const startDate = new Date(formData.startDate);
    const endDate = new Date(formData.endDate);
    const today = new Date();
    today.setHours(0, 0, 0, 0);

    if (startDate < today) {
      alert("Start date cannot be in the past");
      return false;
    }

    if (endDate <= startDate) {
      alert("End date must be after start date");
      return false;
    }

    // Validate minimumOrderValue for UPTO coupon type
    if (formData.couponType === "UPTO") {
      const minOrderValue = parseFloat(formData.minimumOrderValue);
      if (!minOrderValue || minOrderValue <= 0) {
        alert("Minimum order value is required for 'UPTO' coupon type");
        return false;
      }
    }

    return true;
  };

  // ✅ Handle form submission - MULTIPART/FORM-DATA VERSION
  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validateForm()) {
      return;
    }

    try {
      const token = localStorage.getItem("authToken");
      const vendorId = localStorage.getItem("vendorId");

      if (!token || !vendorId) {
        alert("Missing vendor session. Please log in again.");
        return;
      }

      // Generate coupon code from type (first 6 chars uppercase)
      const couponCode = formData.type
        .toUpperCase()
        .replace(/\s+/g, '')
        .slice(0, 6);

      // Prepare payload matching API structure
      const payload = {
        vendorRequirementCouponId: 0,
        couponCode: couponCode || "DEFAULT",
        discount: parseFloat(formData.discount) || 0,
        discountType: formData.discountType,
        couponType: formData.couponType,
        startDate: new Date(formData.startDate).toISOString(),
        endDate: new Date(formData.endDate).toISOString(),
        description: formData.description || "",
        gole: formData.goal || "", // API field name is "gole" (backend typo)
        minimumOrderValue: formData.couponType === "UPTO" 
          ? parseFloat(formData.minimumOrderValue) || 0 
          : 0,
        amount: 0,
        paymentStatus: "PENDING",
        vendorId: parseInt(vendorId) || 0,
        transactionId: "",
        orderId: "",
        // Note: image field is now sent via FormData file
      };

      // Create FormData for multipart upload
      const formDataToSend = new FormData();
      
      // Append JSON data as blob
      formDataToSend.append(
        "couponData",
        new Blob([JSON.stringify(payload)], { type: "application/json" })
      );

      // Append image file if exists
      if (formData.imageFile) {
        formDataToSend.append("image", formData.imageFile, formData.imageFile.name);
      }

      // For debugging - see what's being sent
      // console.log("FormData entries:");
      // for (let [key, value] of formDataToSend.entries()) {
      //   if (value instanceof File) {
      //     console.log(`${key}: ${value.name} (${value.type}, ${value.size} bytes)`);
      //   } else if (value instanceof Blob) {
      //     console.log(`${key}: [Blob] ${value.type}, ${value.size} bytes`);
      //   } else {
      //     console.log(`${key}: ${value}`);
      //   }
      // }

      const response = await axios.post(
        `https://backend.maamaas.com/food/api/vendor/coupon/add/${vendorId}`,
        formDataToSend,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      alert("Coupon request submitted successfully!");
      
      // Reset form
      setFormData({
        type: "",
        description: "",
        goal: "",
        startDate: "",
        endDate: "",
        discount: "",
        discountType: "PERCENTAGE",
        couponType: "FLAT",
        minimumOrderValue: "",
        imageFile: null,
      });
      
      // Cleanup preview
      if (imagePreview) {
        URL.revokeObjectURL(imagePreview);
        setImagePreview(null);
      }
      
      // Close modal and refresh data
      setShowModal(false);
      fetchCoupons();

    } catch (error) {
      console.error("❌ Error submitting coupon:", error);
      console.error("Error response:", error.response?.data);
      alert(`Failed to submit coupon: ${error.response?.data?.message || error.message}`);
    }
  };

  // ✅ Open Pay Now Modal
  const openPayNowModal = async (couponId) => {
    try {
      setLoadingPayNow(true);
      const token = localStorage.getItem("authToken");

      const response = await axios.get(
        `https://backend.maamaas.com/food/api/vendor/coupon/get/${couponId}`,
        { headers: { Authorization: `Bearer ${token}` } }
      );

      setPayNowAmount(response.data.amount || 0);
      setSelectedCouponId(couponId);
      setPayNowModal(true);
    } catch (error) {
      console.error("❌ Error fetching coupon amount:", error);
      alert("Failed to fetch coupon amount");
    } finally {
      setLoadingPayNow(false);
    }
  };

  // ✅ Handle Razorpay Payment
  const handleRazorpayPayment = async () => {
    try {
      const vendorId = localStorage.getItem("vendorId");
      const token = localStorage.getItem("authToken");

      // Fetch vendor details
      const vendorRes = await axios.get(
        `https://backend.maamaas.com/food/api/vendors/${vendorId}`,
        { headers: { Authorization: `Bearer ${token}` } }
      );

      const vendorData = vendorRes.data;
      const vendorMobile = vendorData?.mobileNumber?.toString().trim() || "9999999999";
      const vendorName = vendorData?.ownerName?.trim() || "Vendor";
      const vendorEmail = vendorData?.email?.trim() || "vendor@example.com";

      // Prepare payment details
      const payNowAmountInPaise = Math.round(payNowAmount * 100); // Convert to paise

      const username = "rzp_live_RU5whSMu9rPV7s"; // ⚠️ SECURITY: Move to backend
      const password = "khRC0vtSHCGHktyu62yekZp0"; // ⚠️ SECURITY: Move to backend
      const basicAuth = btoa(`${username}:${password}`);

      // Create Razorpay Order
      const createOrderRes = await axios.post(
        "https://backend.maamaas.com/subscription/api/user/create-order",
        {
          amount: payNowAmountInPaise,
          currency: "INR",
          vendorId,
        },
        {
          headers: {
            Authorization: `Basic ${basicAuth}`,
            "Content-Type": "application/json",
          },
        }
      );

      const { orderId } = createOrderRes.data;
      if (!orderId) throw new Error("Order ID not received");

      // Open Razorpay Checkout
      const options = {
        key: username,
        amount: payNowAmountInPaise,
        currency: "INR",
        name: "Maamaa's",
        description: "Coupon Payment",
        order_id: orderId,
        handler: async (response) => {
          const paymentId = response.razorpay_payment_id;
          const razorpayOrderId = response.razorpay_order_id;

          if (!paymentId || !razorpayOrderId) {
            alert("⚠️ Payment ID or Order ID missing.");
            return;
          }

          try {
            // Capture payment
            await axios.post(
              "https://backend.maamaas.com/subscription/api/user/capture",
              {
                paymentId,
                amount: payNowAmountInPaise,
                currency: "INR",
                vendorId,
              },
              {
                headers: { Authorization: `Basic ${basicAuth}` },
              }
            );

            // Update internal backend
            await axios.put(
              `https://backend.maamaas.com/food/api/vendor/coupon/updatePayment`,
              {},
              {
                params: {
                  vendorRequirementCouponId: selectedCouponId,
                  transactionId: paymentId,
                  orderId: razorpayOrderId,
                },
                headers: { Authorization: `Bearer ${token}` },
              }
            );

            alert("Payment successful and updated!");
            fetchCoupons();
            setPayNowModal(false);
          } catch (captureError) {
            console.error("❌ Payment capture failed:", captureError);
            alert("Payment saved but capture failed.");
          }
        },
        prefill: {
          name: vendorName,
          email: vendorEmail,
          contact: vendorMobile,
        },
        theme: { color: "#b15cd6" },
      };

      const rzp = new window.Razorpay(options);
      rzp.open();
    } catch (error) {
      console.error("❌ Razorpay error:", error);
      alert("Payment failed to initialize.");
    }
  };

  // ✅ Styles
  const tableHeaderStyle = {
    border: "1px solid #ccc",
    padding: "10px",
    backgroundColor: "#b15cd6",
    fontSize: "clamp(12px, 2vw, 16px)",
    textAlign: "center",
    whiteSpace: "nowrap",
    color:"white",
    fontWeight:"500"
  };

  const tableCellStyle = {
    border: "1px solid #ccc",
    padding: "10px",
    textAlign: "center",
    fontSize: "clamp(10px, 2vw, 14px)",
  };

  const imageStyle = {
    width: "60px",
    height: "60px",
    objectFit: "cover",
    borderRadius: "6px",
    border: "1px solid #ccc",
  };

  const paidButtonStyle = {
    backgroundColor: "gray",
    color: "white",
    border: "1px solid #ddd",
    padding: "6px 12px",
    borderRadius: "6px",
    cursor: "not-allowed",
  };

  const payButtonStyle = {
    backgroundColor: "#b15cd6",
    color: "white",
    border: "1px solid #b15cd6",
    padding: "6px 12px",
    borderRadius: "6px",
    cursor: "pointer",
    whiteSpace: "nowrap",
  };

  const inputStyle = {
    padding: '10px',
    border: '1px solid #ccc',
    borderRadius: '6px',
    width: '100%',
    boxSizing: 'border-box',
    fontSize: '14px',
  };

  const selectStyle = {
    ...inputStyle,
    backgroundColor: 'white',
  };

  const labelStyle = {
    display: 'block',
    marginBottom: '5px',
    fontWeight: 'bold',
    fontSize: '14px',
  };

  const modalOverlayStyle = {
    position: 'fixed',
    top: 0,
    left: 0,
    height: '100vh',
    width: '100vw',
    backgroundColor: 'rgba(0,0,0,0.5)',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: 1000,
  };

  const modalContentStyle = {
    backgroundColor: '#fff',
    padding: '20px',
    borderRadius: '10px',
    width: '90%',
    maxWidth: '500px',
    maxHeight: '70vh',
    overflowY: 'auto',
    boxSizing: 'border-box',
  };

  const modalHeaderStyle = {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: '20px',
  };

  const formGroupStyle = {
    marginBottom: '15px',
  };

  const isMobile = window.innerWidth <= 768;

  // Function to close modal and cleanup
  const closeModal = () => {
    setShowModal(false);
    // Cleanup preview URL
    if (imagePreview) {
      URL.revokeObjectURL(imagePreview);
      setImagePreview(null);
    }
  };

  return (
    <div
      style={{
        maxWidth: '1200px',
        width: '100%',
        position: 'relative',
      }}
    >
      {/* Header with Add Button */}
      <div style={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        marginBottom: '20px'
      }}>
        <button
          style={{
            padding: '10px 16px',
            backgroundColor: '#1976d2',
            color: '#fff',
            border: 'none',
            borderRadius: '6px',
            cursor: 'pointer',
            fontWeight: 'bold',
            fontSize: 'clamp(12px, 2vw, 14px)',
          }}
          onClick={() => setShowModal(true)}
        >
          + Request Coupon
        </button>
      </div>

      {/* Table Section */}
      <div style={{
        marginTop: '-15px',
        overflowX: 'auto',
        overflowY: 'auto',
        width: isMobile ? "95vw" : '100%',
        height: 'auto',
        maxHeight:"60vh",
        scrollbarWidth: 'thin',
      }}>
        <div style={{ minWidth: '1000px', width: '100%' }}>
          <table
            style={{
              width: "100%",
              borderCollapse: "collapse",
              backgroundColor: "white",
              border: "1px solid rgba(204, 204, 204, 1)",
              marginTop: "0px",
            }}
          >
            <thead>
              <tr>
                {[
                  "S.No",
                  "Coupon Code",
                  "Coupon Type",
                  "Discount Type",
                  "Description",
                  "Image",
                  "Goal",
                  "Min Order",
                  "Start Date",
                  "End Date",
                  "Discount",
                  "Amount",
                  "Status",
                  "Action",
                ].map((head, i) => (
                  <th key={i} style={tableHeaderStyle}>
                    {head}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {loading ? (
                <tr>
                  <td colSpan="14" style={{ textAlign: "center", padding: "12px" }}>
                    Loading...
                  </td>
                </tr>
              ) : couponRequests.length === 0 ? (
                <tr>
                  <td colSpan="14" style={{ textAlign: "center", padding: "12px" }}>
                    No coupon requests yet.
                  </td>
                </tr>
              ) : (
                couponRequests.map((request, index) => (
                  <tr key={index}>
                    <td style={tableCellStyle}>{index + 1}</td>
                    <td style={tableCellStyle}>{request.couponCode}</td>
                    <td style={tableCellStyle}>
                      {request.couponType === "UPTO" ? "Upto" : "Flat"}
                    </td>
                    <td style={tableCellStyle}>
                      {request.discountType === "PERCENTAGE" ? "Percentage" : "Fixed Amount"}
                    </td>
                    <td style={tableCellStyle}>{request.description}</td>
                    <td style={tableCellStyle}>
                      {request.image ? ( // Assuming backend returns imageUrl for file uploads
                        <img
                          src={request.image} // URL from server
                          alt="Coupon"
                          style={imageStyle}
                        />
                      ) : request.image ? ( // Fallback for Base64 if needed
                        <img
                          src={`data:image/png;base64,${request.image}`}
                          alt="Coupon"
                          style={imageStyle}
                        />
                      ) : (
                        "No Image"
                      )}
                    </td>
                    <td style={tableCellStyle}>{request.gole || "N/A"}</td>
                    <td style={tableCellStyle}>
                      {request.minimumOrderValue > 0 
                        ? `₹${request.minimumOrderValue}` 
                        : "N/A"}
                    </td>
                    <td style={tableCellStyle}>
                      {request.startDate ? new Date(request.startDate).toLocaleDateString("en-GB") : "-"}
                    </td>
                    <td style={tableCellStyle}>
                      {request.endDate ? new Date(request.endDate).toLocaleDateString("en-GB") : "-"}
                    </td>
                    <td style={tableCellStyle}>
                      {request.discountType === "PERCENTAGE" 
                        ? `${request.discount}%` 
                        : `₹${request.discount}`}
                    </td>
                    <td style={tableCellStyle}>₹{request.amount}</td>
                    <td style={tableCellStyle}>
                      <span style={{
                        padding: '4px 8px',
                        borderRadius: '12px',
                        fontSize: '12px',
                        fontWeight: 'bold',
                        backgroundColor: request.paymentStatus === "PAID" ? '#d4edda' : '#f8d7da',
                        color: request.paymentStatus === "PAID" ? '#155724' : '#721c24',
                      }}>
                        {request.paymentStatus}
                      </span>
                    </td>
                    <td style={tableCellStyle}>
                      {request.paymentStatus === "PAID" ? (
                        <button style={paidButtonStyle} disabled>
                          Paid
                        </button>
                      ) : (
                        <button 
                          style={payButtonStyle}
                          onClick={() => openPayNowModal(request.vendorRequirementCouponId)}
                        >
                          Pay Now
                        </button>
                      )}
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      </div>

      {/* Pay Now Modal */}
      {payNowModal && (
        <div style={modalOverlayStyle}>
          <div style={modalContentStyle}>
            <div style={modalHeaderStyle}>
              <h3 style={{ fontSize: 'clamp(16px, 3vw, 20px)', fontWeight: 'bold' }}>Pay Now</h3>
              <button
                style={{
                  background: 'transparent',
                  border: 'none',
                  fontSize: '18px',
                  cursor: 'pointer',
                }}
                onClick={() => setPayNowModal(false)}
              >
                ✕
              </button>
            </div>

            <div style={{ marginTop: '16px', display: 'flex', flexDirection: 'column', gap: '12px' }}>
              {loadingPayNow ? (
                <p>Loading amount...</p>
              ) : (
                <label style={labelStyle}>
                  Amount
                  <input
                    type="number"
                    value={payNowAmount}
                    readOnly
                    style={{ ...inputStyle, fontSize: 'clamp(12px, 2vw, 14px)' }}
                  />
                </label>
              )}

              <button
                style={{
                  padding: '12px',
                  backgroundColor: '#1976d2',
                  color: 'white',
                  fontWeight: 'bold',
                  border: 'none',
                  borderRadius: '6px',
                  cursor: 'pointer',
                  width: 'fit-content',
                  fontSize: 'clamp(12px, 2vw, 14px)'
                }}
                onClick={handleRazorpayPayment}
              >
                Proceed to Pay
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Add Coupon Modal */}
      {showModal && (
        <div style={modalOverlayStyle}>
          <div style={modalContentStyle}>
            <div style={modalHeaderStyle}>
              <h3 style={{ fontSize: 'clamp(16px, 3vw, 20px)', fontWeight: 'bold' }}>Request a Coupon</h3>
              <button
                style={{
                  background: 'transparent',
                  border: 'none',
                  fontSize: '18px',
                  cursor: 'pointer',
                }}
                onClick={closeModal}
              >
                ✕
              </button>
            </div>

            <form onSubmit={handleSubmit} style={{
              display: 'flex',
              flexDirection: 'column',
              gap: '12px',
              marginTop: '16px'
            }}>
              {/* Coupon Name */}
              <div style={formGroupStyle}>
                <label style={labelStyle}>Coupon Code *</label>
                <input
                  type="text"
                  name="type"
                  value={formData.type}
                  onChange={handleChange}
                  required
                  style={inputStyle}
                />
              </div>

              {/* Coupon Type */}
              <div style={formGroupStyle}>
                <label style={labelStyle}>Coupon Type *</label>
                <select
                  name="couponType"
                  value={formData.couponType}
                  onChange={handleChange}
                  required
                  style={selectStyle}
                >
                  <option value="FLAT">Flat Discount</option>
                  <option value="UPTO">Upto Discount</option>
                </select>
                <small style={{ fontSize: '12px', color: '#666' }}>
                  {formData.couponType === "UPTO" 
                    ? "Discount applies only when order value exceeds minimum amount" 
                    : "Discount applies to all orders"}
                </small>
              </div>

              {/* Discount Type */}
              <div style={formGroupStyle}>
                <label style={labelStyle}>Discount Type *</label>
                <select
                  name="discountType"
                  value={formData.discountType}
                  onChange={handleChange}
                  required
                  style={selectStyle}
                >
                  <option value="PERCENTAGE">Percentage (%)</option>
                  <option value="FIXED_AMOUNT">Fixed Amount (₹)</option>
                </select>
              </div>

              {/* Discount Amount */}
              <div style={formGroupStyle}>
                <label style={labelStyle}>
                  {formData.discountType === "PERCENTAGE" 
                    ? "Discount Percentage *" 
                    : "Discount Amount (₹) *"}
                </label>
                <input
                  type="number"
                  name="discount"
                  placeholder={formData.discountType === "PERCENTAGE" ? "10" : "100"}
                  value={formData.discount}
                  onChange={handleChange}
                  min="0"
                  max={formData.discountType === "PERCENTAGE" ? "100" : "10000"}
                  step="0.01"
                  required
                  style={inputStyle}
                />
              </div>

              {/* Minimum Order Value (Only for UPTO coupon type) */}
              {formData.couponType === "UPTO" && (
                <div style={formGroupStyle}>
                  <label style={labelStyle}>Minimum Order Value (₹) *</label>
                  <input
                    type="number"
                    name="minimumOrderValue"
                    placeholder="e.g., 500"
                    value={formData.minimumOrderValue}
                    onChange={handleChange}
                    min="1"
                    required
                    style={inputStyle}
                  />
                  <small style={{ fontSize: '12px', color: '#666' }}>
                    Discount will apply only when order value exceeds this amount
                  </small>
                </div>
              )}

              {/* Goal */}
              <div style={formGroupStyle}>
                <label style={labelStyle}>Goal *</label>
                <input
                  type="text"
                  name="goal"
                  value={formData.goal}
                  onChange={handleChange}
                  required
                  style={inputStyle}
                />
              </div>

              {/* Description */}
              <div style={formGroupStyle}>
                <label style={labelStyle}>Description *</label>
                <textarea
                  name="description"
                  placeholder="Describe this coupon offer in detail..."
                  value={formData.description}
                  onChange={handleChange}
                  rows="3"
                  required
                  style={{ ...inputStyle, minHeight: '80px', resize: 'vertical' }}
                />
              </div>

              {/* Dates */}
              <div style={{
                display: 'flex',
                flexDirection: isMobile ? 'column' : 'row',
                gap: '12px'
              }}>
                <div style={{ flex: 1 }}>
                  <label style={labelStyle}>Start Date *</label>
                  <input
                    type="date"
                    name="startDate"
                    value={formData.startDate}
                    min={new Date().toISOString().split('T')[0]}
                    onChange={handleChange}
                    required
                    style={inputStyle}
                  />
                </div>
                <div style={{ flex: 1 }}>
                  <label style={labelStyle}>End Date *</label>
                  <input
                    type="date"
                    name="endDate"
                    value={formData.endDate}
                    min={formData.startDate || new Date().toISOString().split('T')[0]}
                    onChange={handleChange}
                    required
                    style={inputStyle}
                  />
                </div>
              </div>

              {/* Image Upload - MULTIPART VERSION */}
              <div style={formGroupStyle}>
                <label style={labelStyle}>Coupon Banner Image</label>
                <input
                  type="file"
                  accept="image/*"
                  onChange={handleImageUpload}
                  style={inputStyle}
                />
                {imagePreview && (
                  <div style={{ marginTop: '10px' }}>
                    <img
                      src={imagePreview}
                      alt="Preview"
                      style={{
                        width: '100px',
                        height: '100px',
                        objectFit: 'cover',
                        borderRadius: '6px',
                        border: '1px solid #ddd',
                      }}
                    />
                  </div>
                )}
              </div>

              <button
                type="submit"
                style={{
                  padding: '12px',
                  backgroundColor: '#1976d2',
                  color: 'white',
                  fontWeight: 'bold',
                  border: 'none',
                  borderRadius: '6px',
                  cursor: 'pointer',
                  width: 'fit-content',
                  fontSize: 'clamp(12px, 2vw, 14px)'
                }}
              >
                Submit Coupon Request
              </button>
            </form>
          </div>
        </div>
      )}
    </div>
  );
};

export default Management5;